import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AuthenticationService, BaseComponent, Message} from 'iui-iconectiv-lib';
import {TruncatePipe} from '../shared';

import { InputMask } from 'primeng/inputmask';
import {Table} from 'primeng/table';
import { ObjectUtils } from 'primeng/utils';

import {SearchService} from './search.service';
import {InputParams, QueryResults, SearchModelService} from './search-model.service';

import {TableCode} from './table-code';
import {TableNpb} from './table-npb';
import {TableTn} from './table-tn';
import { SortMeta } from 'primeng/api/sortmeta';


declare var $: any;

// query input ids
const INPUT_TNS = 'input-tns';
const INPUT_TN_FILE = 'input-tn-file';
const INPUT_TN_RANGE = 'input-tn-range';
const INPUT_CODE = 'input-code';
const INPUT_NPB = 'input-npb';


// search by
const BY_TNS = 'byTns';
const BY_TN_FILE = 'byTnFile';
const BY_TN_RANGE = 'byTnRange';
const BY_CODE = 'byCode';
const BY_NPB = 'byNpb';

// button style class
const BTN_DISABLED = 'btn-disabled';
const BTN_DEFAULT = 'btn-default';
const BTN_PRIMARY = 'btn-primary';

// invalid input css class name
const INVALID_INPUT = 'invalid-input';

const NO_RECORD_FOUND = 'No record found.';


// filename for download/ export
const CSV_FILENAME = 'finder-results';

// error message
const ERROR_MESSAGE = 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent extends BaseComponent implements OnInit, AfterViewInit {

  // p-inputMask fields
  @ViewChild('codeMask') codeMask: InputMask;
  @ViewChild('npbMask') npbMask: InputMask;
  @ViewChild('tnRangeMask') tnRangeMask: InputMask;

  // view buttons
  @ViewChild('viewTnRange') viewTnRange: ElementRef;
  @ViewChild('viewCode') viewCode: ElementRef;
  @ViewChild('viewNpb') viewNpb: ElementRef;

  // p-table
  @ViewChild('codeTable') codeTable: Table;
  @ViewChild('blockTable') blockTable: Table;
  @ViewChild('npbTable') npbTable: Table;
  @ViewChild('tnTable') tnTable: Table;

  // <input> of TN file
  @ViewChild('fileInput') fileInput: any;

  // objects contain results table definitions
  dataTableCode = new TableCode();
  dataTableNpb = new TableNpb();
  dataTableTn = new TableTn();

  // user input parameters
  inputParams = new InputParams();

  // REST call results
  queryResults = new QueryResults();

  // search methods
  searchBy = BY_TNS; // by: BY_TNS, BY_TN_FILE, BY_TN_RANGE, BY_CODE, BY_NPB

  // style class for input
  iscTnRange = ''; // css class name; set to "invalid-input" when invalid input is detected.

  sortOrder: SortMeta;

  // style class for Export CSV button
  scBtnExportCsvCode = BTN_DISABLED;
  scBtnExportCsvNpb = BTN_DISABLED;
  scBtnExportCsvTnFile = BTN_DISABLED;
  scBtnExportCsvTnRange = BTN_DISABLED;
  scBtnExportCsvTns = BTN_PRIMARY;

  // style class for View Results button
  scBtnViewTnFile = BTN_DISABLED;
  scBtnViewTnRange = BTN_DISABLED;
  scBtnViewTns = BTN_DEFAULT;
  scBtnViewCode = BTN_DISABLED;
  scBtnViewNpb = BTN_DISABLED;

  // show "Back to Top" when scrolling off the page
  showHome: boolean;

  // show confirmation dialog for getting user's intent of View Results or Export to CSV
  showConfirmationDialog = false;

  // truncate threshold, if the length of the host string is longer, truncation will occur
  // default is 40 characters
  truncateThreshold = 40;


  constructor(
    private searchModelService: SearchModelService,
    private searchService: SearchService,
    private authService: AuthenticationService,
    private truncatePipe: TruncatePipe,
    private cdRef: ChangeDetectorRef
  ) {
    super();  
  }


  ngOnInit() { 
  } 

  ngAfterViewInit(): void {
    this.cdRef.detectChanges(); 
  }

  doViewByTns(table:any) {
    // clear query results
    this.queryResults.reset();
    this.dataTableTn.filters.reset();
    this.dataTableTn.sortOrder.field = '';
    this.dataTableTn.expandedRows = [];
    this.dataTableTn.expandedRowKeys = [];
   
    this.searchModelService.validateTnListRequest(this.inputParams.byTns);
    this.log.debug(`doViewByTns(): this.inputParams.tns=${JSON.stringify(this.inputParams.byTns)}, maxTnsAllowedUi=${this.searchModelService.maxTnsAllowedUi}
    ,sortOrder.field=${this.dataTableTn.sortOrder.field}`);

    if (this.inputParams.byTns.valid === false) {
      return;
    } else {
      // otherwise, call REST service to retrieve request TN data
      // but first let's check if a confirmation message is needed
      // i.e., if the number of the requested TNs exceeds the allowed TNs (maxTnsAllowedUi)
      if (this.inputParams.byTns.needConfirmation) {
        this.confirm();
      } else {
        
        this.getTnListData(BY_TNS);
      }
    }
    
  }


  doViewByTnFile() {
    // clear query results
    this.queryResults.reset();
    this.dataTableTn.filters.reset();
    this.dataTableTn.sortOrder.field = '';
    this.dataTableTn.expandedRows = [];

    // do nothing if there is no input yet
    if (this.inputParams.byTnFile === null) {
      alert('doViewByTnFile - got null');
      return;
    }

    this.searchModelService.validateTnListRequest(this.inputParams.byTnFile);
    //this.log.debug(`doViewByTnFile(): this.inputParams.byTnFile=${JSON.stringify(this.inputParams.byTnFile)}`);

    if (this.inputParams.byTnFile.valid === false) {
      return;
    } else {
      // otherwise, call REST service to retrieve request TN data
      // but first let's check if a confirmation message is needed
      // i.e., if the number of the requested TNs exceeds the allowed TNs (maxTnsAllowedUi)
      if (this.inputParams.byTnFile.needConfirmation) {
        this.confirm();
      } else {
        this.getTnListData(BY_TN_FILE);
      }
    }
  }


  doViewByTnRange() {
    // clear query results
    this.queryResults.reset();
    this.dataTableTn.filters.reset();
    this.dataTableTn.sortOrder.field = '';
    this.dataTableTn.expandedRows = [];
    
    // validate the TN Range input
    this.searchModelService.validateTnRangeRequest(this.inputParams.byTnRange);

    this.log.debug(`doViewByTnRange(): inputParams.tnRange=${JSON.stringify(this.inputParams.byTnRange)}`);
    if (this.inputParams.byTnRange.valid === false) {
      // if invalid input is detected, set style class to invalid-input
      this.iscTnRange = INVALID_INPUT;
    } else {
      // otherwise, call REST service to retrieve request TN data
      // but first let's check if a confirmation message is needed
      // i.e., if the number of the requested TNs exceeds the allowed TNs (maxTnsAllowedUi)
      if (this.inputParams.byTnRange.needConfirmation) {
        this.confirm();
      } else {
        this.getTnRangeData();
      }
    }

  }


  doViewByCode() {
    // clear query results
    this.queryResults.reset();

    this.searchModelService.validateCodeRequest(this.inputParams.byCode);

    // call REST service to retrieve request NPB data
    this.getCodeData();
  }


  doViewByNpb() {
    // clear query results
    this.queryResults.reset();
    this.dataTableTn.expandedRows = [];

    this.searchModelService.validateNpbRequest(this.inputParams.byNpb);

    // call REST service to retrieve request NPB data
    this.getNpbData();
  }

  exportCsvWithHistory(){
    let csv = '\ufeff';
    csv += this.getCsvWithHistory(this.tnTable);
    this.writeToFile(csv, CSV_FILENAME);
  }

  doExportToCsvByTns(includeHistory: boolean) {
    // clear query results
    this.queryResults.reset();

    this.searchModelService.validateTnListRequest(this.inputParams.byTns);
    // this.log.debug(`sc 354: this.inputParams.tns=${JSON.stringify(this.inputParams.tns)}, maxTnsAllowedUi=${this.maxTnsAllowedUi}`);

    if (this.inputParams.byTns.valid === false) {
      return;
    } else {
      this.getTnListDataCsv(BY_TNS, includeHistory);
    }
  }

  doExportToCsvByTnFile(includeHistory: boolean) {
    // clear query results
    this.queryResults.reset();

    // do nothing if there is no input yet
    if (this.inputParams.byTnFile === null) {
      alert('doViewByTnFile - got null');
      return;
    }

    this.searchModelService.validateTnListRequest(this.inputParams.byTnFile);
    // this.log.debug(`doExportToCsvByTnFile(): this.inputParams.byTnFile=${JSON.stringify(this.inputParams.byTnFile)}`);

    if (this.inputParams.byTnFile.valid === false) {
      return;
    } else {
      this.getTnListDataCsv(BY_TN_FILE, includeHistory);
    }
  }


  doExportToCsvByTnRange(includeHistory: boolean) {
    // clear query results
    this.queryResults.reset();

    // validate the TN Range input
    this.searchModelService.validateTnRangeRequest(this.inputParams.byTnRange);

    this.log.debug(`doExportToCsvByTnRange(): inputParams.byTnRange=${JSON.stringify(this.inputParams.byTnRange)}`);
    if (this.inputParams.byTnRange.valid === false) {
      // if invalid input is detected, set style class to invalid-input
      this.iscTnRange = INVALID_INPUT;
    } else {
      this.getTnRangeDataCsv(includeHistory);
    }
  }


  doExportToCsvByCode() {
    // clear query results
    this.queryResults.reset();

    this.searchModelService.validateCodeRequest(this.inputParams.byCode);

    // call REST service to get code data in CSV
    this.getCodeDataCsv();
  }


  doExportToCsvByNpb(includeHistory: boolean) {
     // clear query results
     this.queryResults.reset();

     this.searchModelService.validateNpbRequest(this.inputParams.byNpb);

     // call REST service to retrieve request NPB data
     this.getNpbDataCsv(includeHistory);
  }


  doRestCall(searchBy: string) {
    switch (searchBy) {
      case BY_TNS:
        this.getTnListData(BY_TNS);
        break;
      case BY_TN_FILE:
        this.getTnListData(BY_TN_FILE);
        break;
      case BY_TN_RANGE:
        this.getTnRangeData();
        break;
      case BY_CODE:
        this.getCodeData();
        break;
      case BY_NPB:
        this.getNpbData();
        break;
      default:
        break;
    }
  }


  doRestCallCsv(searchBy: string, includeHistory: boolean) {
    switch (searchBy) {
      case BY_TNS:
        this.getTnListDataCsv(BY_TNS, includeHistory);
        break;
      case BY_TN_FILE:
        this.getTnListDataCsv(BY_TN_FILE, includeHistory);
        break;
      case BY_TN_RANGE:
        this.getTnRangeDataCsv(includeHistory);
        break;
      case BY_CODE:
        this.getCodeDataCsv();
        break;
      case BY_NPB:
        this.getNpbDataCsv(includeHistory);
        break;
      default:
        break;
    }
  }


  /**
   * make REST call to obtain TN data
   * @param type BY_TN_FILE or BY_TNS
   */
  getTnListData(type: string) {
    this.clearMessages();
   // this.inputParams.byTns
    const obj = {
      tnList: this.inputParams[type].restParams
    };
    
    this.searchService.getTnListData(JSON.stringify(obj), type).subscribe(
      res => {
        this.log.debug(`getTnListData(): data=${JSON.stringify(res).substr(0, 2000)}`);
        // clear resutls
        this.queryResults.reset();

        if (res['status'] === 'fail') {
          // set input as invalid
          this.inputParams[type].valid = false;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`search: errorMessage=${errorMessage}`);
          this.displayError();
        } else {
          const response = res['data'];
          const data = response['tnData'];

          if (data.length === 0) {
            // set input as invalid
            this.inputParams[type].valid = false;
            this.inputParams[type].errMsg = NO_RECORD_FOUND;
          } else {
            /**
             * prepare for the result display
             * 1. obtain the query input
             * 2. reset the inputParams
             * 3. obtain the query result
             */
            this.inputParams[type].restParams.forEach((param) => {
              this.queryResults[type].restParams.push(param);
            });
            this.queryResults[type].tnFileName = this.inputParams[type].tnFileName;
            this.inputParams.reset();
            this.inputParams[type].restParams= [];

            this.setTnTableData(data);
            this.queryResults.tnData.by = this.queryResults[type].by;

            this.animateToElementById('can-you-see-me-now');
          }
        }
      },
      error => {
        // set input as invalid
        this.inputParams[type].valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }

    
    );

    
  }


  /**
   * make REST call to obtain a CSV file with TN data
   * @param type BY_TN_FILE or BY_TNS
   */
  getTnListDataCsv(type: string, includeHistory: boolean) {
    // const inputType = type === BY_TN_FILE ? 'tnFile' : 'tns';

    this.clearMessages();

    const obj = {
      tnList: this.inputParams[type].restParamsForBeyond
    };

    this.searchService.getTnListData(JSON.stringify(obj), type, 'csv', includeHistory).subscribe(
      data => {
        // this.log.debug(data);
        this.writeToFile(data, CSV_FILENAME);

        this.inputParams.reset();
      },
      error => {
        // set input as invalid
        this.inputParams[type].valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  /**
   * make REST call to obtain TN Range data
   */
  getTnRangeData() {
    this.clearMessages();
    this.searchService.getTnRangeData(this.inputParams.byTnRange.restParams[0]).subscribe(
      res => {
        this.log.debug(`data=${JSON.stringify(res).substr(0, 2000)}`);
        // clear resutls
        this.queryResults.reset();

        if (res['status'] === 'fail') {
          // set input as invalid
          this.inputParams.byTnRange.valid = false;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`search: errorMessage=${errorMessage}`);
          this.displayError();
        } else {
          const response = res['data'];
          const data = response['tnData'];

          if (data.length === 0) {
            // set input as invalid
            this.inputParams.byTnRange.valid = false;
            this.inputParams.byTnRange.errMsg = NO_RECORD_FOUND;
          } else {
            /**
             * prepare for the result display
             * 1. obtain the query input
             * 2. reset the inputParams
             * 3. obtain the query result
             */
            this.inputParams.byTnRange.restParams.forEach((range) => {
              this.queryResults.byTnRange.restParams.push(range);
            });
            this.inputParams.reset();

            this.setTnTableData(data);
            this.queryResults.tnData.by = this.queryResults.byTnRange.by;

            this.animateToElementById('can-you-see-me-now');
          }
        }
      },
      error => {
        // set input as invalid
        this.inputParams.byTnRange.valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  /**
   * make REST call to obtain a CSV file with TN Range data
   */
  getTnRangeDataCsv(includeHistory: boolean) {
    this.clearMessages();
    this.searchService.getTnRangeData(this.inputParams.byTnRange.restParamsForBeyond[0], 'csv', includeHistory).subscribe(
      data => {
        // this.log.debug(data);
        this.writeToFile(data, CSV_FILENAME);

        this.inputParams.reset();
      },
      error => {
        // set input as invalid
        this.inputParams.byTnRange.valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  /**
   * make REST call to obtain TN data for a given Code
   */
  getCodeData() {
    this.log.debug(`this.inputParams.code=${JSON.stringify(this.inputParams.byCode)}`);
    this.clearMessages();
    this.searchService.getCodeData(this.inputParams.byCode.restLeanParams[0]).subscribe(
      res => {
        this.log.debug(`getCodeData(): data=${JSON.stringify(res).substr(0, 2000)}`);

        if (res['status'] === 'fail') {
          // set input as invalid
          this.inputParams.byCode.valid = false;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`search: errorMessage=${errorMessage}`);
          this.displayError();
        } else {

          // reset result
          this.queryResults.reset();

          const response = res['data'];
          const codeData = response['codeData'];
          const blockData = response['blockData'];

          if (codeData.length === 0) {
            // set input as invalid
            this.inputParams.byCode.valid = false;
            this.inputParams.byCode.errMsg = NO_RECORD_FOUND;
          } else {
            /**
             * prepare for the result display
             * 1. obtain the query input
             * 2. reset the inputParams
             * 3. obtain the query result
             */
            this.inputParams.byCode.restParams.forEach((code) => {
              this.queryResults.byCode.restParams.push(code);
            });
            this.inputParams.byCode.restParams.forEach((code) => {
              this.queryResults.codeBlock.restParams.push(code);
            });
            this.inputParams.reset();

            this.queryResults.byCode.results = codeData;
            this.queryResults.codeBlock.results = blockData;

            this.animateToElementById('can-you-see-me-now');
          }
        }
      },
      error => {
        // set input as invalid
        this.inputParams.byCode.valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  /**
   * make REST call to obtain a CSV file with TN data for a given Code
   */
  getCodeDataCsv() {
    this.log.debug(`this.inputParams.code=${JSON.stringify(this.inputParams.byCode)}`);

    this.clearMessages();
    this.searchService.getCodeData(this.inputParams.byCode.restLeanParams[0], 'csv').subscribe(
      data => {
        // this.log.debug(data);
        this.writeToFile(data, CSV_FILENAME);

        this.inputParams.reset();
      },
      error => {
        // set input as invalid
        this.inputParams.byCode.valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  /**
   * make REST call to obtain TN data for a given NPB
   */
  getNpbData() {
    this.log.debug(`this.inputParams.npb=${JSON.stringify(this.inputParams.byNpb)}`);

    this.clearMessages();
    this.searchService.getNpbData(this.inputParams.byNpb.restLeanParams[0]).subscribe(
      res => {
        this.log.debug(`getNpbData(): data=${JSON.stringify(res).substr(0, 2000)}`);
        // this.log.debug(`sc 676: data=${JSON.stringify(res)}`);

        if (res['status'] === 'fail') {
          // set input as invalid
          this.inputParams.byNpb.valid = false;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`search: errorMessage=${errorMessage}`);
          this.displayError();
        } else {

          // reset result, clean and hide the filter
          this.dataTableTn.showFilters = false;
          this.dataTableTn.filters.reset();
          this.queryResults.reset();

          const response = res['data'];
          const npbData = response['npbData'];
          const tnData = response['tnData'];

          if (npbData.length === 0) {
            // set input as invalid
            this.inputParams.byNpb.valid = false;
            this.inputParams.byNpb.errMsg = NO_RECORD_FOUND;
          } else {
            /**
             * prepare for the result display
             * 1. obtain the query input
             * 2. reset the inputParams
             * 3. obtain the query result
             */
            this.inputParams.byNpb.restParams.forEach((npb) => {
              this.queryResults.byNpb.restParams.push(npb);
            });
            // reset input parameters
            this.inputParams.reset();

            this.queryResults.byNpb.results = npbData;
            
            this.setTnTableData(tnData);
            this.queryResults.tnData.by = this.queryResults.byNpb.by;

            this.animateToElementById('can-you-see-me-now');
          }
        }
      },
      error => {
        // set input as invalid
        this.inputParams.byNpb.valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }

 /**
   * make REST call to obtain a CSV file with TN data for a given NPB
   */
  getNpbDataCsv(includeHistory: boolean) {
    this.log.debug(`this.inputParams.npb=${JSON.stringify(this.inputParams.byNpb)}`);

    this.clearMessages();
    this.searchService.getNpbData(this.inputParams.byNpb.restLeanParams[0], 'csv', includeHistory).subscribe(
      data => {
        // this.log.debug(data);
        this.writeToFile(data, CSV_FILENAME);

        this.inputParams.reset();
      },
      error => {
        // set input as invalid
        this.inputParams.byNpb.valid = false;
        this.log.error(`search: get HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  // change textarea
  changeTextArea(event) {
    this.inputParams.byTns.input = event;

    // remove previously detected invalid input
    if (this.inputParams.byTns.valid !== true) {
      this.inputParams.byTns.valid = true;
    }
  }


  // set focus on field
  setFocusOnView(elr: ElementRef) {
    setTimeout(() => elr.nativeElement.focus(), 0);
  }
  // p-inputMask completed
  doComplete(id) {
    this.log.debug(`doComplete(): id=${id}`);

    switch (id) {
      case INPUT_CODE:
        this.scBtnExportCsvCode = BTN_PRIMARY;
        this.scBtnViewCode = BTN_DEFAULT;
        this.setFocusOnView(this.viewCode);
        break;
      case INPUT_NPB:
        this.scBtnExportCsvNpb = BTN_PRIMARY;
        this.scBtnViewNpb = BTN_DEFAULT;
        this.setFocusOnView(this.viewNpb);
        break;
      case INPUT_TN_RANGE:
        this.scBtnExportCsvTnRange = BTN_PRIMARY;
        this.scBtnViewTnRange = BTN_DEFAULT;
        this.setFocusOnView(this.viewTnRange);
        break;
      default:
        break;
    }
  }


  // when user focus on TN, TN Range, Code, or NPB
  doFocus(id) {
    switch (id) {
      case INPUT_TNS:
        this.inputParams.byTns.valid = true;
        break;
      case INPUT_TN_RANGE:
        this.inputParams.byTnRange.valid = true;
        if (this.iscTnRange !== '') {
          this.iscTnRange = '';
        }
        break;
      case INPUT_CODE:
        this.inputParams.byCode.valid = true;
        break;
      case INPUT_NPB:
        this.inputParams.byNpb.valid = true;
        break;
      default:
        break;
    }
  }


  // methods support file upload
  processUploadedFile(files) {
    this.log.debug(files);
    this.inputParams.byTnFile.tnFileName = files[0]['name'];

    const fileExtension = this.inputParams.byTnFile.tnFileName.split('.').pop();
    if (fileExtension.toLowerCase() === 'csv' || fileExtension.toLowerCase() === 'txt') {
      const reader = new FileReader();
      reader.onload = () => {
        this.inputParams.byTnFile.input = reader.result as string;
        this.inputParams.byTnFile.valid = true;
        this.fileInput.nativeElement.value = ''; // reset the value of <input>
      };

      reader.readAsText(files[0]);
    }
  }


  // confirmation
  confirm() {
    this.showConfirmationDialog = true;
  }


  confirmedToViewResults() {
    // when accepted: continue with a restricted search
    this.log.debug('confirmed to viewResults: ' + this.searchBy);
    this.showConfirmationDialog = false;
    switch (this.searchBy) {
      case BY_TNS:
        this.doRestCall(BY_TNS);
        break;
      case BY_TN_FILE:
        this.doRestCall(BY_TN_FILE);
        break;
      case BY_TN_RANGE:
        this.doRestCall(BY_TN_RANGE);
        break;
      default:
        break;
    }

  }


  confirmedToExportToCsv(includeHistory: boolean) {
    // continue with Export to CSV instead of UI
    this.log.debug('confirmed to exportCsv: ' + this.searchBy);
    this.showConfirmationDialog = false;
    switch (this.searchBy) {
      case BY_TNS:
        this.doRestCallCsv(BY_TNS, includeHistory);
        break;
      case BY_TN_FILE:
        this.doRestCallCsv(BY_TN_FILE, includeHistory);
        break;
      case BY_TN_RANGE:
        this.doRestCallCsv(BY_TN_RANGE, includeHistory);
        break;
      default:
        break;
    }

  }


  getDialogMessage() {
    let multipleTns: string[] = []; 
    let tnCount : number;
    switch (this.searchBy) {
      case BY_TNS:
      multipleTns = this.inputParams.byTns.input.replace(/[^0-9\,\n]/g,'').split(/[\n,]+/).filter(elem => elem !== '' );
      tnCount = multipleTns.length;
        break;
      case BY_TN_FILE:
      multipleTns = this.inputParams.byTnFile.input.replace(/[^0-9\,\n]/g,'').split(/[\n,]+/).filter(elem => elem !== '' );
      tnCount = multipleTns.length;
        break;
      case BY_TN_RANGE:
        const npanxx = this.inputParams.byTnRange.input.substr(0, 3) + this.inputParams.byTnRange.input.substr(4, 3);
        const from = this.inputParams.byTnRange.input.substr(8, 4);
        const to = this.inputParams.byTnRange.input.substr(13, 4);

        const fromInt = parseInt(from, 10);
        const toInt = parseInt(to, 10);
        tnCount = toInt - fromInt + 1;
        break;
      default:
        break;
    }
    

    return `
      You have queried for ${tnCount} TNs.
      The user interface will only display the port details for the first ${this.commafy(this.searchModelService.maxTnsAllowedUi)}
      TNs. <br><br> If you would like to see the port details for the first ${this.commafy(this.searchModelService.maxTnsAllowedUi)}
      TNs, please click Continue. If you would like to see the port details for all the TNs you queried for, please click Export to CSV.
      `;
  }


  // getSearchByXXX() to be used by the template
  getSearchByTns() { return BY_TNS; }
  getSearchByTnFile() { return BY_TN_FILE; }
  getSearchByTnRange() { return BY_TN_RANGE; }
  getSearchByCode() { return BY_CODE; }
  getSearchByNpb() { return BY_NPB; }

  eraseAnyMessages() {
    for(let key in this.inputParams) {
      if (this.inputParams[key].errMsg) {
          this.iscTnRange = '';
          this.inputParams[key].reset();
      }
    }
  }

  // onClick of p-radiobutton
  handleChange() {
    // erase all fields and error msgs (if errors exist) of all search queries when a new search radiobutton is selected
    this.eraseAnyMessages();
  }

  // capture user's sorting preference to be used in a subsequent results
  onSort(event) {
    this.dataTableTn.sortOrder.field = event.field;
    this.dataTableTn.sortOrder.order = event.order;
    // sort will move the paginator back to page 1, so let's reset the index 'first' to 0
    this.dataTableTn.first = 0;
    // this.log.debug(`sc 138: onSort=${JSON.stringify(event)}, this.dataTableTn.sortOrder=${JSON.stringify(this.dataTableTn.sortOrder)}`);
   
  }


  // capture filter changes
  onFilter(event) {
    // sort will move the paginator back to page 1, so let's reset the index 'first' to 0
    this.dataTableTn.first = 0;
  }


  // filters related methods
  openFilters() {
    this.dataTableTn.showFilters = true;
  }


  closeFilters() {
    this.dataTableTn.showFilters = false;
  }


  clearFilters() {
    this.tnTable.reset();
    this.dataTableTn.filters.reset();

    this.tnTable.sortField = this.tnTable.sortField;
    this.tnTable.sortOrder = this.tnTable.sortOrder;
  }


  onTnFilterKeyup(value, field, filterMatchMode) {
    // this.log.debug(`sc 498: value=${JSON.stringify(value)}, field=${JSON.stringify(field)}, filterMatchMode=${JSON.stringify(filterMatchMode)}`);
    // this.log.debug(`sc 499: this.filters.tn=${this.dataTableTn.filters.tn}`);

    const arr = value.replace(/\D/g, '').split('');
    // this.log.debug('"after split - arr: ' + arr);

    // insert '-' into @ 6th
    if (arr.length >= 6 ) {
      arr.splice(6, 0, '-');
    }
    // insert '-' into @ 3th
    if (arr.length >= 3 ) {
      arr.splice(3, 0, '-');
    }

    this.dataTableTn.filters.tn = arr.join('');

    // call p-table filter()
    this.tnTable.filter(this.dataTableTn.filters.tn, field, filterMatchMode);
  }

  // Custom filter to allow 'n/a' in filter fields *n/a filter will only work when whole string is input
  onCustomNaFilter(value, field, filterMatchMode) {
      if (value == 'n/a') {
        setTimeout(() => {
          this.tnTable.filters[field] = { value: [""], matchMode: "in"};
            this.tnTable._filter();
        }, 300);
      }
      else {
        this.tnTable.filter(value, field, filterMatchMode);
      }
  }


  getStyleClass(completed: boolean): string {
    return completed ? BTN_DEFAULT : BTN_DISABLED;
  }


  // style of 'View Results' and 'Export to CSV' buttons
  getScBtnViewTns(): string {
    const completed = this.inputParams.byTns.valid ? this.inputParams.byTns.input.length > 0 : false;
    return completed ? BTN_DEFAULT : BTN_DISABLED;
  }
  getScBtnExportCsvTns(): string {
    const completed = this.inputParams.byTns.valid ? this.inputParams.byTns.input.length > 0 : false;
    return completed ? BTN_PRIMARY : BTN_DISABLED;
  }
  getScBtnViewTnFile(): string {
    const completed = this.inputParams.byTnFile.tnFileName !== '' && this.inputParams.byTnFile.valid ? true : false;
    return completed ? BTN_DEFAULT : BTN_DISABLED;
  }
  getScBtnExportCsvTnFile(): string {
    const completed = this.inputParams.byTnFile.tnFileName !== '' && this.inputParams.byTnFile.valid ? true : false;
    return completed ? BTN_PRIMARY : BTN_DISABLED;
  }
  getFileExportButtonStatus(): boolean {
    const completed = this.inputParams.byTnFile.tnFileName !== '' && this.inputParams.byTnFile.valid ? true : false;
    return completed ? true : false;
  }
  getTNExportButtonStatus(): boolean {
    const completed =  this.inputParams.byTns.valid ? this.inputParams.byTns.input.length > 0 : false;
    return completed ? true : false;
  }
  getTNRangeExportButtonStatus(): boolean {
    const completed =  this.inputParams.byTnRange.valid && this.tnRangeMask ? this.tnRangeMask.isCompleted() : false;
    return completed ? true : false;
  }
  getNPBButtonStatus(): boolean {
    const completed =  this.inputParams.byNpb.valid && this.npbMask ? this.npbMask.isCompleted() : false;
    return completed ? true : false;
  }
  getScBtnViewTnRange(): string {
    const completed =  this.inputParams.byTnRange.valid && this.tnRangeMask ? this.tnRangeMask.isCompleted() : false;
    return completed ? BTN_DEFAULT : BTN_DISABLED;
  }
  getScBtnExportCsvTnRange(): string {
    const completed = this.inputParams.byTnRange.valid && this.tnRangeMask ? this.tnRangeMask.isCompleted() : false;
    return completed ? BTN_PRIMARY : BTN_DISABLED;
  }
  getScBtnViewCode(): string {
    const completed = this.inputParams.byCode.valid && this.codeMask ? this.codeMask.isCompleted() : false;
    return completed ? BTN_DEFAULT : BTN_DISABLED;
  }
  getScBtnExportCsvCode(): string {
    const completed = this.inputParams.byCode.valid && this.codeMask ? this.codeMask.isCompleted() : false;
    return completed ? BTN_PRIMARY : BTN_DISABLED;
  }
  getScBtnViewNpb(): string {
    const completed = this.inputParams.byNpb.valid && this.npbMask ? this.npbMask.isCompleted() : false;
    return completed ? BTN_DEFAULT : BTN_DISABLED;
  }
  getScBtnExportCsvNpb(): string {
    const completed = this.inputParams.byNpb.valid && this.npbMask ? this.npbMask.isCompleted() : false;
    return completed ? BTN_PRIMARY : BTN_DISABLED;
  }


  /**
   * Scroll to the top of the page.
   */
  scrollTop() {
    window.scrollTo(0, 0);
  }

  /**
   * Is the element provided as the argument scrolled into view.
   * @param elem element to check viewability of.
   */
  isScrolledIntoView(elem): boolean {

    const docViewTop = $(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();

    const elemTop = $(elem).offset().top;
    const elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }


  /**
   * Anytime the window is scrolled, this is called.  It checks
   * to see if the home button should be made visible at the bottom
   * of the page.
   */
  onScroll(e: any) {
    this.showHome = !this.isScrolledIntoView($('#can-you-see-me-now'));
  }


  onPage(event) {
    this.dataTableTn.first = event.first;
    this.dataTableTn.rows = event.rows;
  }


  /**
   * add commas, spaces to increase the readability
   * e.g., 123456789.12345679 => 123,456,789.123 456 79
   * @param num - the number to have commas, spaces added
   */
  commafy(num = 0): string {
    const str = num.toString().split('.');
    if (str[0].length >= 4) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 4) {
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
  }


  /**
   * format Code data into CSV and download to local file as 'finder-results.csv'
   * Code data reside in two tables:
   * 1. codeTable
   * 2. blockTable
   *
   */
  downloadCodeData() {
    let csv = '\ufeff';

    csv += this.getCsv(this.codeTable);
    csv += '\n\n';

    if (this.queryResults.codeBlock.results.length === 0) {
      csv += 'No Blocks Found.';
    } else {
      csv += this.getCsv(this.blockTable);
    }

    this.writeToFile(csv, CSV_FILENAME);
  }


  /**
   * format NPB data into CSV and download to local file as 'finder-results.csv'
   * NPB data reside in two tables:
   * 1. npbTable
   * 2. tnTable
   *
   */
  downloadNpbData(includeHistory: boolean) {
    let csv = '\ufeff';

    csv += this.getCsv(this.npbTable);
    csv += '\n\n';
    if (this.queryResults.tnData.results.length === 0) {
      csv += 'No Ported TNs Found.';
    } else {
      if (includeHistory) {
        csv += this.getCsvWithHistory(this.tnTable);
      }
      else {
        csv += this.getCsv(this.tnTable);
      }
    }

    this.writeToFile(csv, CSV_FILENAME);
  }

  /**
   * NOTE: getCsv() is ported from p-table's exportCSV()
   *
   * retrieve and format data into a csv string for a given p-table
   * @param tbl - a p-table from which the data will be retrieved
   * @param optoins - not used
   */
  getCsv(tbl: Table, options?: any): any {
    let data = tbl.filteredValue || tbl.value;
    let csv = '';

    if (options && options.selectionOnly) {
      data = tbl.selection || [];
    }

    // headers
    for (let i = 0; i < tbl.columns.length; i++) {
      const column = tbl.columns[i];
      if (column.exportable !== false && column.field) {
        csv += '"' + (column.header || column.field) + '"';

        if (i < (tbl.columns.length - 1)) {
          csv += tbl.csvSeparator;
        }
      }
    }

    // body
    data.forEach((record, idx) => {
      csv += this.getCsvLine(tbl, record, false);
    });

    return csv;
  }

  /**
   * NOTE: getCsv() is ported from p-table's exportCSV()
   *
   * retrieve and format data into a csv string for a given p-table
   * @param tbl - a p-table from which the data will be retrieved
   * @param optoins - not used
   */
  getCsvWithHistory(tbl: Table): any {
    let data = tbl.filteredValue || tbl.value;
    let csv = '';


    // headers
    for (let i = 0; i < tbl.columns.length; i++) {
      const column = tbl.columns[i];
      if (column.exportable !== false && column.field) {
        csv += '"' + (column.header || column.field) + '"';

        if (i < (tbl.columns.length - 1)) {
          csv += tbl.csvSeparator;
        }
      }
    }

    // body
    data.forEach((record, idx) => {
      csv += this.getCsvLine(tbl, record, false);
      if (record.tnHistory) {
        record.tnHistory.forEach((history, i) => {
          csv += this.getCsvLine(tbl, history, true);
        });
      }
    });

    return csv;
  }

  private getCsvLine(tbl: Table, record: any, isHistoryRow: boolean) {
    var csv = '\n';
    for (let i = 0; i < tbl.columns.length; i++) {
      const column = tbl.columns[i];
      if (column.exportable !== false && column.field) {
        let cellData = ObjectUtils.resolveFieldData(record, column.field);

        if (cellData != null) {
          cellData = String(cellData).replace(/"/g, '""');
        }
        else {
          cellData = '';
        }

        //Don't print TN for history rows
        if(isHistoryRow && column.field === "tn"){
          cellData = '';
        }

        csv += '"' + cellData + '"';

        if (i < (tbl.columns.length - 1)) {
          csv += tbl.csvSeparator;
        }
      }
    }
    return csv;
  }

  /**
   * NOTE: this code is ported from p-table's exportCSV()
   *
   * flush input string to a named disk file
   * @param csv - input csv string
   * @param outputFilename - output filename
   */
  writeToFile(csv, outputFilename) {
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const nav = (window.navigator as any);

    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, outputFilename + '.csv');
    }
    else {
      const link = document.createElement('a');
      link.style.display = 'none';
      document.body.appendChild(link);
      if (link.download !== undefined) {
        link.setAttribute('href', URL.createObjectURL(blob));
        link.setAttribute('download', outputFilename + '.csv');
        link.click();
      }
      else {
        csv = 'data:text/csv;charset=utf-8,' + csv;
        window.open(encodeURI(csv));
      }
      document.body.removeChild(link);
    }

  }


  /**
   * call base class's displayErrorMessage() for error.
   */
  displayError() {
    this.displayErrorMessage(new Message('Error', ERROR_MESSAGE));
  }

  /**
   * prepare retrieved TN data for display
   * if there is only one row of data, expands it
   */
  setTnTableData(data: any) {
    // assign data to the binding variable of the TN Table
    this.queryResults.tnData.results = data;
    // detect if this is single row scenario
    if (data.length === 1) {
      console.log("data[0].tn:" + this.dataTableTn.expandedRows);
      // set expandedRowKeys
      this.dataTableTn.expandedRows[data[0].tn] = true;
    } else if (data.length > 1) {
      // reset expandedRowKeys
      this.dataTableTn.expandedRows[data[0].tn] = null;
    }

    // study truncate uri
    // if (data && data.length > 0) {
    // data[0].mmsUri   = 'http://__mms__r.a1234567890123456789012z0034567890.com:8080/a1234567890/';
    // data[0].smsUri   = 'http://__sms__r.a1234567890123456789012z0034567890.com:8080/a1234567890/';
    // data[0].voiceUri = 'http://__voice__a1234567890123456789012z0034567890.com:8080/a1234567890/';
    // }
  }


  /**
   * transform string for display, truncate the string if it is longer than the threshold
   */
  getUri(uri: string): string {
    if (uri && uri.length > 0) {
      return this.truncatePipe.transform(uri, this.truncateThreshold);
    } else {
      return 'n/a';
    }
  }

  /**
   * prepare tooltip string for the associate truncated string
   */
  getToolTip(uri: string): string {
    if (uri && uri.length > 0) {
      return uri;
    } else {
      return '';
    }
  }

  getStatusToolTip(field: string, value: string): string {
    
    if (field=='status') {
      switch (value) {
        case 'Native':
          return'The TN is not ported.';
          case 'Ported-pool':
          return'The TN is not ported and part of a pool block.';
          case 'Ported-inter':
          return'TN port event from one service provider to another.';
          case 'Ported-intra':
          return'TN port event within the service provider.';
          case 'Snapback-inter':
          return'Disconnect event after an inter-port. TN returned to the block/code owner.';
          case 'Snapback-intra':
          return'Disconnect event after an intra-port. TN returned to the block/code owner.';
          case 'Snapback':
          return'Disconnect event where the LNP Type was not provided. TN returned to the block/code owner."';
        default :
         return '';
      }
    }
  }
}

